// Initialize filters when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    initializeFilters();
    initializeDropdown();
    initializeStickyFilter();
});

function initializeFilters() {
    let filters = document.getElementsByClassName('filter-item');

    Array.from(filters).forEach(filter => {
        filter.onclick = function () {
            var elems = document.querySelectorAll(".filter-item.selected");
            [].forEach.call(elems, function (el) {
                el.classList.remove("selected");
            });
        
            this.classList.add("selected");
            let targetId = this.getAttribute("data-target");

            const yOffset = -100; 
            const element = document.getElementById(targetId);
            const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

            window.scrollTo({top: y, behavior: 'smooth'});
        }    
    });
}

function initializeDropdown() {
    const dropdownTrigger = document.getElementById('dropdown-trigger');
    const dropdownContent = document.getElementById('dropdown-content');
    const dropdownOverlay = document.getElementById('dropdown-overlay');
    const dropdownItems = document.querySelectorAll('.dropdown-item');
    
    if (dropdownTrigger && dropdownContent) {
        // Toggle dropdown
        dropdownTrigger.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            dropdownContent.classList.toggle('expanded');
            
            // If opening dropdown, check if we need to scroll
            if (!isExpanded) {
                // Wait for dropdown to expand, then check position
                setTimeout(() => {
                    const dropdownRect = dropdownContent.getBoundingClientRect();
                    const dropdownBottom = dropdownRect.bottom;
                    const viewportHeight = window.innerHeight;
                    
                    // If dropdown bottom is below the viewport, scroll to make it visible with 100px padding
                    if (dropdownBottom > viewportHeight) {
                        // Calculate the scroll position needed to show the dropdown bottom with 100px padding
                        const currentScrollY = window.scrollY;
                        const scrollAmount = dropdownBottom - viewportHeight + 100;
                        const targetScrollY = currentScrollY + scrollAmount;
                        
                        window.scrollTo({
                            top: targetScrollY,
                            behavior: 'smooth'
                        });
                    }
                }, 100); // Increased delay to ensure dropdown has fully expanded
            }
            
            // Toggle overlay
            if (dropdownOverlay) {
                if (!isExpanded) {
                    // Calculate where the dropdown ends
                    const triggerRect = this.getBoundingClientRect();
                    const dropdownHeight = dropdownContent.scrollHeight; // Height of expanded dropdown
                    const overlayStartY = triggerRect.bottom + dropdownHeight + window.scrollY;
                    
                    // Get the full document height
                    const documentHeight = Math.max(
                        document.body.scrollHeight,
                        document.body.offsetHeight,
                        document.documentElement.clientHeight,
                        document.documentElement.scrollHeight,
                        document.documentElement.offsetHeight
                    );
                    
                    // Position overlay to start below the dropdown and extend to end of DOM content
                    dropdownOverlay.style.top = overlayStartY + 'px';
                    dropdownOverlay.style.left = '0';
                    dropdownOverlay.style.right = '0';
                    dropdownOverlay.style.height = (documentHeight - overlayStartY) + 'px';
                    dropdownOverlay.style.bottom = 'auto';
                }
                dropdownOverlay.classList.toggle('active');
            }
        });
        
        // Handle dropdown item selection
        dropdownItems.forEach(item => {
            item.addEventListener('click', function() {
                const target = this.getAttribute('data-target');
                
                // Update dropdown items
                dropdownItems.forEach(di => {
                    di.classList.remove('selected');
                    di.setAttribute('aria-selected', 'false');
                });
                this.classList.add('selected');
                this.setAttribute('aria-selected', 'true');
                
                // Update desktop filter items
                updateDesktopSelection(target);
                
                // Close dropdown
                dropdownTrigger.setAttribute('aria-expanded', 'false');
                dropdownContent.classList.remove('expanded');
                
                // Hide overlay
                if (dropdownOverlay) {
                    dropdownOverlay.classList.remove('active');
                }
                
                // Scroll to target
                scrollToTarget(target);
            });
            
            // Keyboard navigation
            item.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.click();
                }
            });
        });
        
        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!dropdownTrigger.contains(e.target) && !dropdownContent.contains(e.target)) {
                dropdownTrigger.setAttribute('aria-expanded', 'false');
                dropdownContent.classList.remove('expanded');
                
                // Hide overlay
                if (dropdownOverlay) {
                    dropdownOverlay.classList.remove('active');
                }
            }
        });
        
        // Close dropdown when clicking overlay
        if (dropdownOverlay) {
            dropdownOverlay.addEventListener('click', function() {
                dropdownTrigger.setAttribute('aria-expanded', 'false');
                dropdownContent.classList.remove('expanded');
                this.classList.remove('active');
            });
        }
        
        // Keyboard navigation for dropdown trigger
        dropdownTrigger.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    }
}

function initializeStickyFilter() {
    const filtersSection = document.getElementById('filters-section');
    
    // Check if sticky is enabled via the data attribute
    if (!filtersSection || filtersSection.getAttribute('data-sticky-enabled') !== 'true') {
        return;
    }
    
    let filtersSectionTop = 0;
    let isSticky = false;
    let lastScrollTop = 0;
    
    function updateStickyState() {
        if (!filtersSection) return;
        
        // Only apply sticky behavior on mobile (screen width <= 749px)
        if (window.innerWidth > 749) {
            // Remove sticky class on desktop
            if (isSticky) {
                filtersSection.classList.remove('sticky');
                isSticky = false;
            }
            return;
        }
        
        // Get the initial position of the filters section
        if (filtersSectionTop === 0) {
            filtersSectionTop = filtersSection.offsetTop;
        }
        
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const isScrollingDown = scrollTop > lastScrollTop;
        
        if (scrollTop > filtersSectionTop && !isSticky) {
            filtersSection.classList.add('sticky');
            isSticky = true;
            
            // Close dropdown and hide overlay when becoming sticky
            closeDropdownAndOverlay();
        } else if (scrollTop <= filtersSectionTop && isSticky) {
            filtersSection.classList.remove('sticky');
            isSticky = false;
        } else if (isSticky && isScrollingDown) {
            // If already sticky and scrolling down, close dropdown to prevent overlay issues
            closeDropdownAndOverlay();
        }
        
        lastScrollTop = scrollTop;
    }
    
    function closeDropdownAndOverlay() {
        const dropdownTrigger = document.getElementById('dropdown-trigger');
        const dropdownContent = document.getElementById('dropdown-content');
        const dropdownOverlay = document.getElementById('dropdown-overlay');
        
        if (dropdownTrigger && dropdownContent) {
            dropdownTrigger.setAttribute('aria-expanded', 'false');
            dropdownContent.classList.remove('expanded');
        }
        
        if (dropdownOverlay) {
            dropdownOverlay.classList.remove('active');
        }
    }
    
    // Update sticky state on scroll
    window.addEventListener('scroll', updateStickyState);
    
    // Update sticky state on resize
    window.addEventListener('resize', function() {
        filtersSectionTop = 0; // Reset to recalculate
        updateStickyState();
    });
    
    // Initial check
    updateStickyState();
}

function updateDesktopSelection(targetId) {
    const filterItems = document.querySelectorAll('.filter-item');
    
    filterItems.forEach(fi => {
        fi.classList.remove('selected');
        if (fi.getAttribute('data-target') === targetId) {
            fi.classList.add('selected');
        }
    });
}

function scrollToTarget(targetId) {
    const yOffset = -40; 
    const element = document.getElementById(targetId);
    if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
    }
}

